// extracted by mini-css-extract-plugin
export var fullWidthButton = "_100-0";
export var tagInputDisabled = "_100-1";